import React from 'react'
import PropTypes from 'prop-types'

import styled from '@emotion/styled'

import useWindowSize from '../hooks/useWindowSize'

const StyledRoot = styled.div(({ styles, theme }) => ({
  boxSizing: 'border-box',
  color: theme.colors.dark_grey,
  fontFamily: theme.fonts.primary,
  fontSize: theme.fontSize,
  lineHeight: `${theme.lineHeight}px`,
  fontWeight: theme.fontWeight,
  '& *, & *::before, & *::after': {
    boxSizing: 'inherit',
  },
  ...styles,
}))

const StyledWrapper = styled.div(({ width, height }) => ({
  width,
  height,
}))

const BaseWrapper = ({ children, className }) => {
  const { height } = useWindowSize()
  return (
    <StyledRoot>
      <StyledWrapper className={className} width="100%" height={height}>
        {children}
      </StyledWrapper>
    </StyledRoot>
  )
}

BaseWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({}),
  ]),
  className: PropTypes.string,
}

BaseWrapper.defaultProps = {
  className: null,
  children: [],
}

export default React.memo(BaseWrapper)
